module.exports = __webpack_public_path__ + "static/media/due-port04.f32b72a9.jpg";